import zhMessages from '../locales/zh-CN.json'

const ZhLan = {
  messages: {
    ...zhMessages
  },
  locale: 'zh-CN',
}
export default ZhLan
